// @flow
import * as React from "react"
import {
  FixedBottom,
  FixedBottomSpacer,
} from "componentsStyled/Layout/FixedBottom"
import Button from "components/Button"
import type { OriginalReservation } from "data/reservations/types"
import ConfirmExtension from "../ConfirmExtension"

type Props = {
  originalReservation: ?OriginalReservation,
  addToBasket: boolean,
  loading: boolean,
  submit: Function,
}
const ReservationActions = ({
  originalReservation,
  addToBasket,
  loading,
  submit,
}: Props) => {
  function renderInner() {
    if (originalReservation) {
      return (
        <ConfirmExtension
          loading={loading}
          originalReservation={originalReservation}
        />
      )
    } else if (addToBasket) {
      return (
        <Button
          fullwidth
          onClick={submit}
          loading={loading}
          disabled={loading}
        >
          Add to Cart
        </Button>
      )
    } else {
      return (
        <Button
          fullwidth
          onClick={submit}
          loading={loading}
          disabled={loading}
        >
          Confirm
        </Button>
      )
    }
  }
  return (
    <React.Fragment>
      <FixedBottomSpacer />
      <FixedBottom>
        {renderInner()}
      </FixedBottom>
    </React.Fragment>
  )
}

export default ReservationActions



// WEBPACK FOOTER //
// ./src/pages/Checkout/CheckoutForm/ReservationActions/index.js